import React from "react";
import { Navigate } from "react-router-dom";

import { useIsDashmoteStaff } from "../hooks/useIsDashmoteStaff";

// Only allow access if the user is a Dashmote staff member and not a synthetic
// (demo/test) account. Shares `useIsDashmoteStaff` with the sidebar so what the
// rail offers and what this guard admits are the same question — they used to
// be two, and the guard was the looser of the pair.
const UserManagementProtectedRoute = ({ children }) => {
  const isStaff = useIsDashmoteStaff();

  if (isStaff) {
    return children;
  }
  return (
    <Navigate
      to="/"
      replace
    />
  );
};

export default UserManagementProtectedRoute;
